module.exports = __webpack_public_path__ + "static/image/sustainability/m/img-protection-1@3x.ver2_0_2.png?efaf3d62";